module.exports = __webpack_public_path__ + "img/196.d8bbe3a4.jpg";